export default function getChangedFields<T extends Record<string, any>>(
  original: T,
  updated: Partial<T>
): { isEmpty: boolean; changedFields: Partial<T> } {
  const changedFields: Partial<T> = {};

  Object.keys(updated).forEach((key) => {
    const originalValue = original[key];
    const updatedValue = updated[key];

    if (originalValue !== updatedValue) {
      changedFields[key as keyof T] = updatedValue;
    }
  });

  return { isEmpty: !Object.keys(changedFields)?.length, changedFields };
}
